<template>
  <div v-if="loaded && !cancelled && !consented" class="w-screen fixed z-30 bottom-20 sm:bottom-0 left-0 px-4">
    <div class="mx-auto my-4 max-w-6xl w-full bg-primary shadow-xl rounded p-3 sm:flex items-center justify-between text-secondary">
      <div class="mr-6 text-sm">
        <p class="font-semibold">
          {{ $t('components.cookiePermissions.likeCookies') }}
        </p>
        <p>
          {{ $t('components.cookiePermissions.weUseCookies', {location: $site.location.title}) }}
        </p>
      </div>

      <div class="flex items-center space-x-2  rtl:space-x-reverse mt-6 sm:mt-0">
        <b-button variant="outline" @click="cancel">
          {{ $t('components.cookiePermissions.cancel') }}
        </b-button>

        <b-button variant="action" @click="accept">
          {{ $t('components.cookiePermissions.accept') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import * as cookie from 'cookie'

const { enableAnalytics } = useGtag()

interface Props {
  layout?: string
}

const props = withDefaults(defineProps<Props>(), {
  layout: 'site'
})

const emit = defineEmits(['accepted', 'cancelled'])

const loaded = ref(false)
const cancelled = ref(false)
const consented = ref(false)

const consentedCookieValid = computed(() => {
  const cookies = cookie.parse(document.cookie)
  return (cookies.__bookapp_cookie_consent === 'true')
})

onMounted(() => {
  loaded.value = true
  consented.value = consentedCookieValid.value

  if (consented.value) {
    accepted()
  }
})



const accepted = () => {
  enableAnalytics();

  emit('accepted')
}

const accept = () => {
  const config = useRuntimeConfig().public
  document.cookie = cookie.serialize('__bookapp_cookie_consent', 'true', { domain: config.deployDomain })

  consented.value = true

  accepted()
}

const cancel = () => {
  cancelled.value = true

  emit('cancelled')
}
</script>